import axios from '../utils/axios/index.js';

export const fetchInformationCenter = async () => {
  try {
    const [supportResponse, notificationResponse, announcementResponse] = await Promise.all([
      axios.get('/api/informationcenter/support'),
      axios.get('/api/informationcenter/notification'),
      axios.get('/api/informationcenter/announcement')
    ]);

    return {
      support: supportResponse.data,
      notification: notificationResponse.data,
      announcement: announcementResponse.data
    };
  } catch (error) {
    console.error(error);
  }
};


// WEBPACK FOOTER //
// ./src/api/information-center.js